
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const CustomDetailsApi = createApi({
  reducerPath: "CustomDetailsApi",
  baseQuery,
  tagTypes: ["CustomDetails"],
  endpoints: (builder) => ({
    getCustomMaster: builder.query({
      query: ({ id }) =>`/customer/Customedetails/${id}`,
      transformResponse: (response) => response?.data?.[0] ?? [],
      providesTags: ["CustomDetails"],
    }),
    createCustomMaster: builder.mutation({
      query: ({ id, ...data }) => ({
        url:`/customer/Customedetails/${id}`, 
        method: "PUT",
        headers: { 
          "X-Request-Id": Math.random().toString(36).substring(2)
        },
        body: { customeMaster: data },
      }),
      invalidatesTags: ["CustomDetails"],
    }),
  }),
});

export const {
   useLazyGetCustomMasterQuery,
   useCreateCustomMasterMutation
} = CustomDetailsApi;
